import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { useTranslation } from 'react-i18next'
import RaceCard from '../RaceCard'
import dayjs from 'dayjs'

const sectionHeading = {
  fontSize: { xs: '1.25rem', md: '1.6rem' },
  fontWeight: 700,
  textAlign: 'center',
  mb: 3
}

export default function CardsView ({ races = [] }) {
  const { t } = useTranslation('races')
  const now = dayjs()

  const annotated = races.map(race => {
    const firstEventDate = dayjs(race.date?.[0])
    const lastEventDate = race.date?.length > 1 ? dayjs(race.date[1]) : firstEventDate
    const ended = race.status === 'ended' || now.isAfter(lastEventDate.endOf('day'))
    return { race, firstEventDate, ended }
  })

  const future = annotated
    .filter(({ ended }) => !ended)
    .sort((a, b) => a.firstEventDate.diff(b.firstEventDate))

  const past = annotated
    .filter(({ ended }) => ended)
    .sort((a, b) => b.firstEventDate.diff(a.firstEventDate))

  return (
    <Box>
      {future.length > 0 && (
        <Box sx={{ mb: 6 }}>
          <Typography component='h2' sx={sectionHeading}>
            {t('upcomingRaces')}
          </Typography>
          <Grid container spacing={4}>
            {future.map(({ race, ended }) => (
              <RaceCard key={race.slug} {...{ race }} ended={ended} />
            ))}
          </Grid>
        </Box>
      )}

      {past.length > 0 && (
        <Box>
          <Typography component='h2' sx={sectionHeading}>
            {t('pastRaces')}
          </Typography>
          <Grid container spacing={4}>
            {past.map(({ race, ended }) => (
              <RaceCard key={race.slug} {...{ race }} ended={ended} />
            ))}
          </Grid>
        </Box>
      )}
    </Box>
  )
}
